import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { fetchPersonalDetails, FETCH_PERSONAL_DETIALS} from "../../actions/student.action"

function* handleFetchPersonalDetails(action) {
  try {
    const { data : resData} = yield call(studentAPI.fetchPersonalDetails, action.payload);
    //extract the data here     
    yield put(fetchPersonalDetails.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(fetchPersonalDetails.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* fetchPersonalDetailsSaga() {
  yield takeLatest(FETCH_PERSONAL_DETIALS.REQUEST, handleFetchPersonalDetails);
}

export default fetchPersonalDetailsSaga;
